import { AppContext } from "App"
import { TournamentContext } from "components/Tournament/__Tournament.context"
import { TournamentBiographyRecord } from "data/TournamentBiographyRecord"
import React, { useContext, useState } from "react"
import { Data as DataHelper } from 'helpers/data'
import useAsyncEffect from "use-async-effect"
import Warning from "components/utils/Warning"
import { Text } from "static/text"
import Loading from "components/utils/Loading"
import { ItemWrapper } from "styles/common"
import TournamentBiographyForm from "./Form"

const Detail: React.FC<{ isNew?: boolean }> = (p) => {
  const { db: a_db, alert: a_alert, locked: a_locked } = useContext(AppContext)

  const { params: t_params } = useContext(TournamentContext)

  // --------------------- Load Data --------------------- //
  const [content, setContent] = useState<{
    data?: TournamentBiographyRecord
    load: {
      isInProgress?: boolean
      isNewRecord?: boolean
      isError?: boolean
    }
  }>()

  useAsyncEffect(async () => {
    if (!t_params?.tournament_id) return

    setContent((prev) => ({ ...prev, load: { isInProgress: true } }))

    try {
      const _data = await DataHelper.GetTournamentBiographyByTournamentId(
        a_db!,
        t_params?.tournament_id,
        {
          alert: a_alert
        }
      )

      setContent((prev) => ({
        ...prev,
        data: _data,
        load: { isInProgress: false, isNewRecord: !_data },
      }))
    } catch {
      setContent((prev) => ({
        ...prev,
        load: { isInProgress: false, isError: true }
      }))
    }
  }, [t_params])

  // ---------------------- Handlers --------------------- //
  const handleLockedChange = (isLocked: boolean) => {
    a_locked?.set(isLocked)
  }

  if (content?.load.isError) return <Warning text={Text.NoServerData} />

  if (content?.load.isInProgress) return <Loading />

  return (
    <>
      <ItemWrapper>
        <TournamentBiographyForm
          data={(content?.data)}
          state={content?.load.isNewRecord ? 'new' : 'existing'}
          locked={{
            value: a_locked?.value ?? false,
            callback: handleLockedChange,
          }}
        />
      </ItemWrapper>
    </>
  )
}

export default Detail
